var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 381,
    viewBox: "0 0 272 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 381,
    rx: 8,
    fill: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7541 201.588C52.3937 201.588 50 197.115 50 192.679C50 189.648 50.9843 186.159 52.6338 183.34C54.2165 180.619 56.1356 179 57.7541 179C59.368 179 61.2863 180.619 62.8829 183.34C64.5246 186.159 65.5082 189.648 65.5082 192.679C65.5082 197.115 63.1096 201.588 57.7541 201.588ZM99.3443 185.748H104.852V200.176H110.754V185.748H116.262V180.412H99.3443V185.748ZM128.632 185.748H137.41V180.412H128.633C120.568 180.412 116.262 184.384 116.262 190.294C116.262 196.204 120.568 200.176 128.633 200.176H137.41V194.84H128.632C124.9 194.84 122.446 193.518 122.446 190.294C122.446 187.07 124.9 185.748 128.632 185.748ZM87.644 180.412L84.5396 192.209L81.435 180.412H71.1475V200.176H76.9706L76.9709 184.1L81.2011 200.176H87.8779L92.111 184.09V200.176H97.9344V180.412H87.644Z",
    fill: "#E30611"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.838 179.699H144.276V193.824H148.058V183.24L150.204 193.824H154.558L156.705 183.199V193.824H160.793V179.699H154.66L152.759 189.238L150.838 179.699ZM173.973 193.824V190.446H167.329V188.194H172.256V184.919H167.329V183.076H173.953V179.699H163.241V193.824H173.973ZM175.093 196.894H178.977V193.824H187.195V196.894H191.079V190.343H189.239V179.699H177.526V185.246C177.526 187.907 177.096 189.525 176.524 190.343H175.093V196.894ZM185.151 183.179V190.343H180.531C181.062 189.525 181.308 187.907 181.308 185.246V183.179H185.151ZM197.187 193.824L201.663 185.512V193.824H205.752V179.699H201.172L196.696 188.01V179.699H192.608V193.824H197.187ZM211.53 179.699L207.177 193.824H210.897L211.694 191.121H216.682L217.5 193.824H221.814L217.459 179.699H211.53ZM214.188 182.831L215.763 188.051H212.615L214.188 182.831Z",
    fill: "#E30611"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1fb7da3197133cc6902e8ddb14bba089.svg";
export { ForwardRef as ReactComponent };